import {
  SIDE_MENU_BLOCK_INFO_START,
  SIDE_MENU_BLOCK_INFO_SUCCESS,
  SIDE_MENU_BLOCK_INFO_ERROR
} from '../../constants';
import { getSideMenu as query } from '../../lib/graphql';

export function getSideMenu() {
  return async (dispatch, getState, { client }) => {
    try {
      dispatch({
        type: SIDE_MENU_BLOCK_INFO_START,
      });

      const { data } = await client.query({
        query,
        fetchPolicy: 'network-only'
      });
      if (data?.getSideMenu) {
        // Successully logged out
        dispatch({
          type: SIDE_MENU_BLOCK_INFO_SUCCESS,
          payload: {
            sideMenu: data.getSideMenu
          }
        });

      } else {
        dispatch({
          type: SIDE_MENU_BLOCK_INFO_ERROR,
        });
      }
    } catch (error) {
      dispatch({
        type: SIDE_MENU_BLOCK_INFO_ERROR,
        payload: {
          error
        }
      });
      return false;
    }
    return true;
  };
}
